import * as React from "react";

const Phone: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M19.125 15.125C19.375 15.125 19.5833 15.2083 19.75 15.375C19.9167 15.5417 20 15.75 20 16V19.125C20 19.375 19.9167 19.5833 19.75 19.75C19.5833 19.9167 19.375 20 19.125 20C14.9305 20 11.3611 18.5278 8.41667 15.5833C5.47221 12.6389 4 9.06947 4 4.875C4 4.625 4.08333 4.41667 4.25 4.25C4.41667 4.08333 4.625 4 4.875 4H8C8.25 4 8.45833 4.08333 8.625 4.25C8.79167 4.41667 8.875 4.625 8.875 4.875C8.875 6.01389 9.05555 7.08333 9.41667 8.08333C9.52778 8.41667 9.45833 8.70833 9.20833 8.95833L7.25 10.9167C8.58334 13.5 10.5417 15.4583 13.125 16.7917L15.0833 14.8333C15.2778 14.5833 15.5694 14.5139 15.9583 14.625C17.0417 14.9583 18.0972 15.125 19.125 15.125Z" fill="currentColor"/>
        </svg>
    );
};

export default React.memo(Phone);
